import React from "react";

const initialState = {
  lang: "en",
  isDark: false,
  userInfo: null,
};

const reducer = (state, action) => {
  console.log("context app", { state, action });
  const { type, payload = {} } = action;
  if (type) {
    // type todo
    return state;
  }

  return { ...state, ...payload };
};

export const AppContext = React.createContext();

export const AppProvider = ({ payload, children }) => {
  const [state, dispatch] = React.useReducer(reducer, {
    ...initialState,
    ...(payload || {}),
  });

  return (
    <AppContext.Provider value={[state, dispatch]}>
      {children}
    </AppContext.Provider>
  );
};
